import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { TwitterLogo, GithubLogo, LinkedinLogo } from "@phosphor-icons/react";

const footerLinks = {
  product: [
    { label: "Features", href: "#features" },
    { label: "Security", href: "#security" },
    { label: "Enterprise", href: "#enterprise" },
    { label: "Pricing", href: "/pricing" },
  ],
  resources: [
    { label: "Documentation", href: "/docs" },
    { label: "API Reference", href: "/api" },
    { label: "Blog", href: "/blog" },
    { label: "Community", href: "/community" },
  ],
  company: [
    {
      label: "About Us",
      href: "https://www.linkedin.com/company/ai-code-review-dev/about/",
    },
    {
      label: "Careers",
      href: "https://www.linkedin.com/company/ai-code-review-dev/jobs/",
    },
    { label: "Contact", href: "mailto:hello@aicodereview.dev" },
    // { label: "Partners", href: "/partners" },
  ],
  legal: [
    { label: "Privacy", href: "/privacy" },
    { label: "Terms", href: "/terms" },
    { label: "Security", href: "/security" },
    { label: "Status", href: "https://ai-code-review.instatus.com/" },
  ],
};

export function Footer() {
  return (
    <footer className="mt-32 bg-[rgba(3,0,20,0.95)] border-t border-white/[0.08] backdrop-blur-3xl">
      <div className="container mx-auto px-4">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-16">
          <div className="space-y-4">
            <h3 className="font-display text-sm font-semibold tracking-wider text-white/90 uppercase">
              Product
            </h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="font-display text-sm font-semibold tracking-wider text-white/90 uppercase">
              Resources
            </h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="font-display text-sm font-semibold tracking-wider text-white/90 uppercase">
              Company
            </h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="font-display text-sm font-semibold tracking-wider text-white/90 uppercase">
              Legal
            </h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/[0.08] py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Logo & Copyright */}
            <div className="flex items-center gap-4">
              <Link to="/" className="flex items-center gap-3 group">
                <motion.img
                  src="/acr-logo.svg"
                  alt="AI Code Review"
                  className="h-6 w-auto"
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                />
                <span className="font-display text-lg font-bold bg-gradient-to-r from-white to-white/70 bg-clip-text text-transparent">
                  AI Code Review
                </span>
              </Link>
              <div className="font-primary text-sm text-white/60">
                © {new Date().getFullYear()} AI Code Review. All rights
                reserved.
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-6">
              <motion.a
                href="https://x.com/AiCodeReview"
                className="footer-link"
                whileHover={{ y: -1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <TwitterLogo size={20} weight="bold" />
              </motion.a>
              <motion.a
                href="https://github.com/AiCodeReview"
                className="footer-link"
                whileHover={{ y: -1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <GithubLogo size={20} weight="bold" />
              </motion.a>
              <motion.a
                href="https://www.linkedin.com/company/ai-code-review-dev"
                className="footer-link"
                whileHover={{ y: -1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <LinkedinLogo size={20} weight="bold" />
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
